module.exports = __webpack_public_path__ + "static/media/pastorchristian.d89afad9.jpg";